export const breakpoints = {
  values: {
    xs: 0,
    sm: 475,
    md: 768,
    lg: 1386,
    xl: 1536,
  },
} as const;

export const isMobile = (width: number): boolean => width < breakpoints.values.md;
export const isTablet = (width: number): boolean =>
  width >= breakpoints.values.md && width < breakpoints.values.lg;
export const isDesktop = (width: number): boolean => width >= breakpoints.values.lg;

export type ResponsiveSize = 'mobile' | 'tablet' | 'desktop';

export const getResponsiveSize = (width: number): ResponsiveSize => {
  if (width < breakpoints.values.md) return 'mobile';
  if (width < breakpoints.values.lg) return 'tablet';
  return 'desktop';
};
